"use client";

import React from "react";
import RegistrationForm from "./RegistrationForm";

const HeroSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[#1B365E]">
      {/* Decorative brand glows */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-[#40BFDE]/20 blur-3xl" />
        <div className="absolute -right-16 top-1/3 h-72 w-72 rounded-full bg-[#FF5758]/15 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-64 w-64 rounded-full bg-[#FFBC41]/10 blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto flex max-w-350 flex-col gap-10 px-4 pb-14 sm:px-6 sm:pb-20 sm:pt-32 lg:gap-14 lg:pb-24 lg:pt-36">
        {/* ── Value proposition ─────────────────────────────────────────── */}
        <div className="text-center">
          <h1 className="mt-6 font-red-hat text-[30px] font-light leading-9.25 tracking-[0.2px] text-white sm:text-[46px] sm:leading-[1.1] lg:text-[56px]">
            Attirez{" "}
            <span className="bg-linear-to-r from-[#40BFDE] to-[#7FE0F5] bg-clip-text text-transparent">
              de nouveaux apprenants
            </span>{" "}
            pour vos formations
          </h1>
        </div>

        {/* ── Form card ─────────────────────────────────────────────────── */}
        <div className="w-full">
          <div className="mx-auto w-full max-w-xl rounded-3xl bg-white p-6 shadow-2xl shadow-black/20 sm:p-8">
            <div className="mb-6 text-center">
              <h2 className="font-red-hat text-[24px] font-semibold leading-8 text-[#1B365E]">
                Inscrivez votre organisme
              </h2>
              <p className="mt-1.5 text-[13px] leading-5 text-[#1D1D1D]/70">
                Complétez ce formulaire, notre équipe s&apos;occupe du reste.
              </p>
            </div>
            <RegistrationForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
